<div matDialogContent>
  <mat-form-field (keydown.enter)="search()">
    <mat-label>Search</mat-label>
    <input matInput type="text" [(ngModel)]="query" maxlength="100" />
    @if (query) {
    <button matSuffix matIconButton aria-label="Clear" (click)="query=''">
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>
  @if (history.length>0) {
  <div class="history">
    <span>Search History:</span>
    @for (q of history; track $index) {
    <a routerLink="/search" [queryParams]="{q: q}">{{q}}</a>
    }
  </div>
  }
</div>
